import { Trans } from '@lingui/react/macro';

import { useAIVisibilitySettings } from '@/api/aiVisibility';
import { useCurrentInstanceSettings } from '@/api/organization';
import PageError from '@/components/errors/PageError';
import { PageSpinner } from '@/components/loaders';

import AIVisibilitySettingsForm from './AIVisibilitySettingsForm';

type AIVisibilitySettingsProps = {
  onDirtyChange?: (isDirty: boolean) => void;
  onWorkflowStarted?: () => void;
};

const AIVisibilitySettings = ({ onDirtyChange, onWorkflowStarted }: AIVisibilitySettingsProps) => {
  const { instanceDetails, isLoading: isInstanceLoading } = useCurrentInstanceSettings();
  const { settings, isLoading: isSettingsLoading, error, mutate } = useAIVisibilitySettings();

  if (isInstanceLoading || isSettingsLoading || instanceDetails == null) {
    return <PageSpinner />;
  }

  if (error || settings == null) {
    return (
      <PageError
        message={<Trans>An error occurred while loading your AI Visibility settings</Trans>}
        detail={<Trans>Please refresh the page and try again</Trans>}
        headingLevel={2}
      />
    );
  }

  return (
    <AIVisibilitySettingsForm
      domain={instanceDetails.domain}
      settings={settings}
      mutate={mutate}
      onDirtyChange={onDirtyChange}
      onWorkflowStarted={onWorkflowStarted}
    />
  );
};

export default AIVisibilitySettings;
